// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__2gEqJ","anim":"Projects_anim__2_Lax","Project":"Projects_Project__3ZNDh","animP":"Projects_animP__2VF4R"};